import React from 'react';
import './check-box.scss';

const CheckBox = ({ 
  label     = '',
  checked   = '',
  className = '',
  theme     = 'checkbox',
  size      = 'md',
  name      = 'checkbox',
  isDisabled = false,
  onChange = () => {} 
}) => {
  const classes = ['check__container', ...className.split(' '), theme, size];

  if (checked) {
    classes.push('checked');
  }

  if (isDisabled) {
    classes.push('disabled');
  }

  return (
    <label className={classes.join(' ')} onChange={onChange} name={name}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={isDisabled} />
      {label}
      <span className="checkmark"></span>
    </label>
  );
};

export default CheckBox;
